import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormActions } from "../utils/FormActions";
import { PlayerMetadataFields } from "./PlayerMetadataFields";
export var PlayerForm = function (_a) {
    var _b, _c, _d;
    var onSubmit = _a.onSubmit, player = _a.player, onCancel = _a.onCancel;
    var _e = useForm({
        defaultValues: {
            nationality: (player === null || player === void 0 ? void 0 : player.nationality) || "US",
            heading: (player === null || player === void 0 ? void 0 : player.heading) || 50,
            passing: (player === null || player === void 0 ? void 0 : player.passing) || 50,
            defending: (player === null || player === void 0 ? void 0 : player.defending) || 50,
            positioning: (player === null || player === void 0 ? void 0 : player.positioning) || 50,
            finishing: (player === null || player === void 0 ? void 0 : player.finishing) || 50,
            speed: (player === null || player === void 0 ? void 0 : player.speed) || 50,
            fitness: (player === null || player === void 0 ? void 0 : player.fitness) || 50,
            keeping: (player === null || player === void 0 ? void 0 : player.keeping) || 50,
            dribbling: (player === null || player === void 0 ? void 0 : player.dribbling) || 50,
            shooting: (player === null || player === void 0 ? void 0 : player.shooting) || 50,
            tackling: (player === null || player === void 0 ? void 0 : player.tackling) || 50,
            crossing: (player === null || player === void 0 ? void 0 : player.crossing) || 50,
            leadership: (player === null || player === void 0 ? void 0 : player.leadership) || 50,
            communication: (player === null || player === void 0 ? void 0 : player.communication) || 50,
            bio: (_b = player === null || player === void 0 ? void 0 : player.bio) !== null && _b !== void 0 ? _b : "",
            foot: (player === null || player === void 0 ? void 0 : player.foot) || "Right",
            positionOne: (_c = player === null || player === void 0 ? void 0 : player.positionOne) !== null && _c !== void 0 ? _c : "GK",
            positionTwo: (_d = player === null || player === void 0 ? void 0 : player.positionTwo) !== null && _d !== void 0 ? _d : "",
        },
    }), control = _e.control, handleSubmit = _e.handleSubmit;
    return (_jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(function (data) {
            onSubmit(data);
        }), noValidate: true, sx: { mt: 1 }, children: [_jsx(PlayerMetadataFields, { control: control }), _jsx(FormActions, { submitLabel: player === undefined ? "Create" : "Update", onCancel: onCancel })] }));
};
